import { GetStaticProps } from 'next';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import md from 'markdown-it';
import getFaqs from '../lib/getFaqs';
import Link from 'next/link';
import Head from 'next/head';

export const getStaticProps: GetStaticProps = async (context) => {
  const faqObject = getFaqs();

  const newFaqObject:any = {
    'about-this-website': {},
    'about-the-horus-heresy': {},
    'about-the-reading-order': {},
    'about-other-questions': {}
  }

  for (const key in faqObject) {
    if (Object.prototype.hasOwnProperty.call(faqObject, key)) {
      faqObject[key].data['q-and-a'].map((element: any) => {
        element.renderedBody = md().render(element.body)
      })
    }
  }

  for (const key in faqObject) {
    if (Object.prototype.hasOwnProperty.call(faqObject, key)) {
      newFaqObject[key] = faqObject[key];
    }
  }

  return {
    props: {
      newFaqObject
    }
  }
}

export default function Faq({ newFaqObject }: any) {
  return (
    <>
      <Head>
          <title>Horus Heresy Omnibus Project - FAQ</title>
          <meta name="description" content="A Fan-Created Guide for Navigating the Epic Series" />
          <link rel="icon" href="/favicon.ico" />
        </Head>

    <main>
      <div>
        <section className='bg-heresy-bg-default rounded-t-sm pt-24 pb-24 bg-center bg-cover bg-no-repeat'>
          <h1 className='text-center text-3xl p-4'>Frequently asked questions</h1>
        </section>
        {Object.keys(newFaqObject).map((sectionKey: any, index: any) => {
          return (
          <section className='p-4 xl:mr-40 xl:ml-40' key={'faq-section' + index}>
            <h2 className='text-2xl text-heresy-primary mb-1 text-center'>{newFaqObject[sectionKey].data['section-title']}</h2>
            <ol>
              {newFaqObject[sectionKey].data['q-and-a'].map((element: any, index: any) => (
                <li key={index} className=''>
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex justify-center items-center mb-4 w-full px-4 py-2 lg:text-lg max-w-prose ml-auto mr-auto font-medium text-left text-heresy-font-light hover:text-heresy-font-default bg-heresy-bg-default rounded-lg hover:bg-heresy-bg-dark focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                          <span className='basis-11/12'>{element.question}</span>
                          <ChevronDownIcon
                            className={`${open ? 'transform rotate-180' : ''
                              } h-6 w-6 basis-1/12 text-heresy-primary`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-heresy-font-light">
                          <div className='prose prose-invert lg:prose-lg mr-auto ml-auto' dangerouslySetInnerHTML={{ __html: element.renderedBody }} />
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                </li>
              ))}
            </ol>
          </section>)
        })}
        <section>
          <h1 className='text-center text-3xl p-4'>Still have a question?</h1>
          <p className='text-center p-4'>If you cannot find an answer to your question in out FAQ, you can contact us and we will answer to you shortly.</p>
        </section>
      </div>
    </main>
    </>
  );
}
